import { Component, inject, Input, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SimpleHgType } from 'lion-api';
import { DatePipe } from '@angular/common';
import { TradeTransactionStore } from '@shared/data';

@Component({
  selector: 'app-form-valuta',
  templateUrl: './form-valuta.component.html',
  styleUrl: './form-valuta.component.scss',
  standalone: false
})
export class FormValutaComponent implements OnChanges {
  @Input() attachForm?: FormGroup;
  @Input() disableHolidaysForFaelligkeitSelection?: boolean;
  @Input() renderStartvalutaFeld?: boolean;
  @Input() renderFaelligkeitFeld?: boolean;
  @Input() renderStartvalutaCalendar?: boolean;
  @Input() renderFaelligkeitCalendar?: boolean;
  @Input() renderStartvalutaDropDown?: boolean;
  @Input() renderTage?: boolean;
  @Input() tradeType?: SimpleHgType;
  @Input() availableValutae?: Date[];
  protected availableValutaeForSelect: { label: string; value: Date }[] = [];
  private datePipe = inject(DatePipe);
  private tradeTransactionStore = inject(TradeTransactionStore);

  get dayDiff(): number {
    const endRaw = this.attachForm?.get('faelligkeit')?.value;
    const startRaw = this.attachForm?.get('startValuta')?.value;

    if (!endRaw || !startRaw) return 0;

    const end = new Date(endRaw);
    const start = new Date(startRaw);

    // Ensure dates are valid before performing math
    if (isNaN(end.getTime()) || isNaN(start.getTime())) return 0;

    // Use UTC to avoid issues with Daylight Saving Time
    const utcEnd = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    const utcStart = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());

    const diffMs = Math.abs(utcEnd - utcStart);
    const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;
    const diffD = diffMs / MILLISECONDS_PER_DAY;

    return Math.round(diffD);
  }

  get minDate(): Date | undefined {
    if (this.tradeType === SimpleHgType.Termingeld) {
      return undefined;
    }
    if (this.availableValutae) {
      return this.availableValutae?.length > 0 ? this.availableValutae[0] : undefined;
    }
    return undefined;
  }

  get maxDate(): Date | undefined {
    if (this.availableValutae) {
      return this.availableValutae[2];
    }
    return undefined;
  }

  ngOnChanges() {
    if (this.availableValutae) {
      this.availableValutaeForSelect = this.availableValutae.map((date) => ({
        label: this.datePipe.transform(date, 'dd.MM.yyyy') || '',
        value: date
      }));
    }
  }

  protected focusFaelligkeit() {
    setTimeout(() => {
      const inputFaelligkeit = document.getElementById('form_faelligkeit_input') as HTMLInputElement;
      if (inputFaelligkeit) {
        inputFaelligkeit.focus();
      }
    }, 200);
  }

  protected onYearMonthInputMatch($event: boolean) {
    this.tradeTransactionStore.updateIsMonthYearInput($event);
  }
}
